import * as React from "react";
import Switch from "@mui/material/Switch";
import { SwitchButtonProps } from "../../interface/input";


export default function SwitchButton({
  handleChange,
  value,
}: SwitchButtonProps) {

  return (
    <Switch
      checked={value}
      onChange={handleChange}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
}
